export enum SigninResponse {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_LOCKOUT_ENABLED_IN_PERIOD = 'USER_LOCKOUT_ENABLED_IN_PERIOD',
  USER_LOCKOUT_ENABLED = 'USER_LOCKOUT_ENABLED',
  USER_EMAIL_NOT_VERIFY = 'USER_EMAIL_NOT_VERIFY',
}

export enum UploadAssetInvalidResponse {
  FILE_ALREADY_EXISTS = 'FileAlreadyExists',
  FILE_TYPE_NOT_SUPPORTED = 'FileTypeNotSupported',
  INVALID_IMAGE_SIZE_MINIMUM = 'InvalidImageSizeMinimum',
  INVALID_VIDEO_DURATION = 'InvalidVideoDuration',
  INVALID_VIDEO_RESOLUTION = 'InvalidVideoResolution',
}

export enum ResetPasswordResponse {
  TOKEN_NOT_FOUND = 'TokenNotFound',
  TOKEN_IS_USED = 'TokenIsUsed',
  TOKEN_NOT_ACTIVE = 'TokenNotActive',
  TOKEN_EXPIRED = 'TokenExpired',
  USER_NOT_FOUND = 'UserNotFound',
  RESET_PASSWORD_FAIL = 'ResetPasswordFail',
  USER_TYPE_NOT_USERNAME_PASSWORD = 'UserTypeNotUsernamePassword',
}

export enum ForgotPasswordResponse {
  USER_TYPE_NOT_USERNAME_PASSWORD = 'UserTypeNotUsernamePassword',
}